import bsGetEnv from "../BsGetEnv";
import bsGetCid from "../BsGetCid";
import bsGetCapis from '../BsGetcapis'
import BsGetLocation from '../BsGetLocation'
import {toast} from '../VnToast'
import ajax from '../BsAjax'
// import getNowtime from './../../bs/bs-get-nowtime'
import bsUtil from "../BsUtil";
import silent from './silent'
let comData = {
    // isEnv:0,
    needlogin:false,
    canClick:true,
    codebtn:'获取验证码',
    newUser:false,
    getcode,
    loginActive,
}

function getcode(phone) {
    if (!phone) {
        toast('请输入手机号')
    } else if (/^1[3-9]\d{9}$/.test(phone)) {
        sendCode(phone);
    } else {
        toast('手机号格式错误')
    }
}

function backUp(success) {

    function getQueryVariable(name, hash){
        const reg = new RegExp("(^|&)" + name+ "=([^&]*)(&|$)", "i");
        const result = hash.match(reg);
        return result !==null ? decodeURI(result[2]) : ''
    }
    window.addEventListener("hashchange", async () => {
        var hash = location.hash.replace('#', '').split("?")[0]
        var cid = getQueryVariable('user_cid', hash)
        var access_token = getQueryVariable('access_token', hash)
        var appId = getQueryVariable('appId', hash)
        var changeType = getQueryVariable('changeType', hash) // changeType作为后续和小程序交互预留字段
        if(sessionStorage.getItem('cid') && !changeType) return
        if (bsUtil.queryString('useHash') && hash && access_token && cid) {
            sessionStorage.setItem("cid", cid);
            sessionStorage.setItem("access_token", access_token);
            sessionStorage.setItem("appId", appId);
            bsGetCid({
                cid,
                access_token
            });
            success({
                cid,
                access_token
            })
            history.go(-1)
        }
    }, false);
}

function pinkUrl(){
    let sear = []
    let query = bsUtil.getQuery()
    Object.keys(query).forEach(function(item){
        if(item.indexOf('cid')===-1 && item.indexOf('access_token') === -1){
            sear.push(item + "=" + query[item]);
        }
    });
    return sear.join('&')
}
async function init(success, reset, isSilent, error){
    let {cid, access_token} = await bsGetCid();
    // 判断是否需要登录
    if(!cid || !access_token || reset){
        if (bsGetEnv.inApplication) {
            // app内
            window.location = bsGetEnv.isDidaPinche ? 'didapinche://login?isBack=1': 'didataxi://login?isBack=1';
        }else if(bsGetEnv.inWechat){
            wx.miniProgram.getEnv(async function(res) {
                if (res.miniprogram) {
                    sessionStorage.setItem("isToLogin", true);
                    // 微信小程序内
                    await backUp(success)
                    const url = 'https://' + location.host + window.location.pathname + '?' + pinkUrl()
                    wx.miniProgram.navigateTo({ url: '/pagesWebView/subLogin/subLogin?backUrl=' + btoa(encodeURIComponent((JSON.stringify(url)))) })
                    
                } else {
                    // 微信非小程序环境
                    if(isSilent){
                        await silent(function(data){
                            if (data.code === 1) {
                                comData.needlogin = true,
                                comData.newUser = data.newUser
                            } else {
                                bsUtil.setCookie('cid', data.cid);
                                bsUtil.setCookie('access_token', data.access_token);
                                bsGetCid({
                                    cid: data.cid,
                                    access_token: data.access_token
                                });
                                success({
                                    cid: data.cid,
                                    access_token: data.access_token
                                })
                            }
                        },'', error);
                    } else {
                        comData.needlogin = true
                    }
                }
            })
        }else if(bsGetEnv.isAlipay && window.my){
            window.my.getEnv(async (res)=>{
                if (res.miniprogram) {
                    await backUp()
                  // 在支付宝小程序中打开
                   const url = 'https://' + location.host + window.location.pathname + '?' + pinkUrl() 
                   window.my.navigateTo({ url: '/pagesWebView/subLogin/subLogin?backUrl=' + btoa(encodeURIComponent((JSON.stringify(url)))) })
                } else {
                    comData.needlogin = true;
                }
            })
        } else {
            comData.needlogin = true
        }
    } else {
        success({
            cid: cid,
            access_token: access_token
        })
    }
    return comData
}
// 发送验证码
async function sendCode(mobile){
    let loaction = await BsGetLocation();
    // 发送验证码
    ajax.post(bsGetCapis + '/web/user/sendCode', bsUtil.stringify({
        actid: 'h5',
        mpno: mobile
        }), {
        ddcinfo: {
            identifier: 'webConpouShareNew.h5',
            latitude: loaction.latitude,
            longitude: loaction.longitude,
            location_time: bsUtil.nowTime()
        }
    }).then(({ data = {}}) => {
          if (data.code === 0) {
                toast('验证码已发送')
                let seconds = 60
                comData.canClick = false // 禁用获取验证码按钮
                comData.codebtn = '重新发送' + seconds + 's'
                let timer = setInterval(() => {
                    comData.codebtn = '重新发送' + --seconds + 's'
                    if (seconds <= 0) {
                        comData.canClick = true // 打开获取验证码按钮
                        comData.codebtn = '获取验证码'
                        clearInterval(timer)
                        timer = null
                    }
                }, 1000)
          } else {
            toast(data.message)
          }
        }).catch(e => {
          failed(e.message)
        })
}
async function loginActive(phone, code, success, close) {
    const testphone = /^1[3-9]\d{9}$/;
    let loaction = await BsGetLocation();
    if (phone && code && testphone.test(phone)) {
        ajax.post(bsGetCapis + '/web/user/h5/signin', bsUtil.stringify({
            code: code,
            mpno: phone,
            client_id: 'h5',
            source_cid: 'couponTemplate'
          }), {
            ddcinfo: {
              identifier: 'webConpouShareNew.h5',
              latitude: loaction.latitude,
              longitude: loaction.longitude,
              location_time: bsUtil.nowTime()
            }
        }).then(async ({ data = {}}) => {
            if (data.code === 0) {
                toast('登录成功');
                if(!bsGetEnv.inApplication){
                    bsUtil.setCookie('cid', data.cid);
                    bsUtil.setCookie('access_token', data.access_token);
                }
                bsGetCid({
                    cid: data.cid,
                    access_token: data.access_token
                });
                if(comData.newUser){
                    comData.newUser = false;
                    await silent(success, data.phone, ()=>{}, close, code);
                    return;
                }
                success({
                    cid: data.cid,
                    access_token: data.access_token,
                    phone
                })
                close();
            } else {
                toast(data.message)
            }
        }).catch(e => {
            toast(e.message)
        })
    } else if (!phone) {
        toast('请输入手机号')
    } else if (!testphone.test(phone)) {
        toast('手机号格式错误')
    } else if (!code) {
        toast('请输入验证码')
    }
}

export default init
